var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRetakePhoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_863_1696)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.67504 0.669223C2.67628 0.393083 2.45342 0.168229 2.17728 0.166997C1.90114 0.165765 1.67629 0.388622 1.67505 0.664762L1.66902 2.01745C1.66676 2.52069 1.66488 2.94044 1.70173 3.27789C1.74038 3.63184 1.82678 3.95806 2.04609 4.24145C2.10548 4.31819 2.17084 4.38999 2.24153 4.45619C2.28316 4.49517 2.32664 4.53222 2.37183 4.56719C2.65521 4.7865 2.98143 4.8729 3.33539 4.91155C3.67284 4.9484 4.09256 4.94652 4.59581 4.94426L5.94852 4.93822C6.22466 4.93699 6.44751 4.71214 6.44628 4.436C6.44505 4.15986 6.22019 3.937 5.94405 3.93823L4.62025 3.94414C4.08063 3.94655 3.71818 3.94741 3.44395 3.91746C3.42333 3.91521 3.40359 3.91281 3.3847 3.91028C3.66037 3.59946 3.96695 3.31667 4.29961 3.06674C5.33031 2.29235 6.61083 1.83366 7.99992 1.83366C11.4057 1.83366 14.1666 4.59457 14.1666 8.00033C14.1666 11.4061 11.4057 14.167 7.99992 14.167C4.59416 14.167 1.83325 11.4061 1.83325 8.00033C1.83325 7.72418 1.60939 7.50033 1.33325 7.50033C1.05711 7.50033 0.833252 7.72418 0.833252 8.00033C0.833252 11.9584 4.04188 15.167 7.99992 15.167C11.958 15.167 15.1666 11.9584 15.1666 8.00033C15.1666 4.04228 11.958 0.833659 7.99992 0.833659C6.38681 0.833659 4.89688 1.36721 3.69893 2.26725C3.33676 2.53935 3.00124 2.84497 2.69695 3.17951L2.69582 3.16933C2.66587 2.8951 2.66673 2.53264 2.66914 1.99303L2.67504 0.669223Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_863_1696"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetakePhoto);
export default __webpack_public_path__ + "static/media/RetakePhoto.d45dc7d7f42aa4b3af6cce57f3916ebe.svg";
export { ForwardRef as ReactComponent };